import {Directive, Input, SimpleChanges} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from "@angular/forms";
import {ColumnMapping} from "../../Services/import.service";

@Directive({
    selector: '[awCustomFieldValidator]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: CustomFieldValidatorDirective, multi: true }
    ]
})
export class CustomFieldValidatorDirective implements Validator {
  @Input() customFieldPropertyNames: ColumnMapping[];
  private _onChange: () => void;
  
  constructor() { }

  registerOnValidatorChange(fn: () => void): void {
    this._onChange = fn;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const val = control.value;
    if (this.customFieldPropertyNames.filter(cfp => cfp.PropertyName == val && cfp.PropertyName != null
        && cfp.PropertyName != "").length > 1) {
      return {
        'duplicate': true
      }
    }
    return undefined;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this._onChange) this._onChange();
  }

}
